<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
        <h4 style="padding-left: 6px">{{ i18nValues["productAdmin"] }}</h4>
        <el-button
          v-if="componentsMap.get('product_create')"
          icon="fas fa-plus"
          size="small"
          class="btn-primary"
          @click="add()"
        >
          {{ i18nValues["add"] }}
        </el-button>
      </div>

      <!-- form -->
      <div class="grid-body no-border borderBottom">
        <el-form v-loading="loading != 0">
          <div class="filters-wrapper">
            <div class="filters-row">
              <el-form-item :label="i18nValues['experimentalCode']" prop="experimentalCode">
                <el-input
                  v-model="filter.experimentalCode"
                  :placeholder="i18nValues['experimentalCode']"
                ></el-input>
              </el-form-item>

              <el-form-item :label="i18nValues['variety']" prop="name">
                <el-input
                  v-model="filter.name"
                  :placeholder="i18nValues['variety']"
                ></el-input>
              </el-form-item>

              <el-form-item label="Brand" prop="brand">
                <el-input
                  v-model="filter.brand"
                  placeholder="Brand"
                ></el-input>
              </el-form-item>

              <!-- Event -->
              <el-form-item :label="i18nValues['event']" prop="event">
                <el-select
                  v-model="filter.event"
                  :placeholder="i18nValues['event']"
                  filterable
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in EventsList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- search button  -->
              <el-button
                @click="retrieveProductsBySearch()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>
            </div>
          </div>

          <!-- table -->
          <el-form-item prop="products">
            <div class="full-width" style="margin:0 auto;padding:20px;">
              <el-table
                :key="tableSortKey"
                :data="ProductSubList"
                id="ProductTable"
                class="table table-hover"
                align="center"
                :empty-text="i18nValues['noDataAvailable']"
                :default-sort="tableDefaultSort"
                stripe
                @sort-change="handleSortChange"
              >
                <!-- Product Experimental Code -->
                <el-table-column
                  prop="experimentalCode"
                  :label="i18nValues['experimentalCode']"
                  width="85"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Product Name -->
                <el-table-column
                  prop="name"
                  label="Variety"
                  width="75"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Product Type -->
                <el-table-column
                  prop="cropType"
                  :label="i18nValues['crop']"
                  width="75"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Product Brand -->
                <el-table-column
                  prop="brand"
                  label="brand"
                  width="75"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- Product Event detailedTrait -->
                <el-table-column
                  prop="event.detailedTrait"
                  :label="i18nValues['detailedTrait']"
                  width="75"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- EDIT/DELETE -->
                <el-table-column width="90" align="right">
                  <template slot-scope="scope">
                    <el-button
                      v-if="isReadOnly()"
                      fixed="right"
                      class="text-info"
                      icon="fa fa-eye"
                      size="small"
                      :title="i18nValues['view']"
                      @click="edit(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if="componentsMap.get('product_modification')"
                      class="text-info"
                      icon="fas fa-edit"
                      size="small"
                      :title="i18nValues['edit']"
                      @click="edit(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if="componentsMap.get('product_delete')"
                      class="text-danger"
                      icon="fas fa-times"
                      size="small"
                      :title="i18nValues['remove']"
                      @click="deleteProduct(scope.row.id)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="90 > 10" style="height: 15px"></div>
              <div class="pagination-bar">
                <PaginationFunctional
                  ref="pagination"
                  sublistName="ProductSubList"
                  :fullList="ProductList"
                  :tableSize="20"
                  :tableIndexInitial="initialPage"
                  @paginationChange="paginationChange"
                  @currentIndexPagination="setCurrentPage"
                />
                <div v-if="ProductList.length > 0" class="results-info">
                  <p>
                    {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                  </p>
                </div>
              </div>
          </div>
          </el-form-item>

        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
export default {
  name: "ProductAdmin",
  created() {
    this.restoreFromQuery();
    // Wait for events to load before running search (needed for event filter to work properly)
    this.eventsPromise = this.retrieveEvents().then(() => {
      // After events are loaded, run initial search if campaign is available
      if (
        this.globalCampaign &&
        this.globalCampaign.id &&
        !this.hasBootstrappedInitialSearch
      ) {
        this.hasBootstrappedInitialSearch = true;
        // Preserve deep-linked page on first load
        this.runInitialSearch({ preservePage: true });
      }
    });
    this.retrieveProductCount();
  },

  components: {
    PaginationFunctional,
  },

  computed: {
    loading: get("product/loading"),
    globalCampaign: get("globalCampaign"),

    // Pagination helpers for results label
    currentPage() {
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
        return this.$refs.pagination.tableIndex;
      }
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      if (Array.isArray(this.ProductList)) {
        return this.ProductList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    tableDefaultSort() {
      if (this.sortProp && this.sortOrder) {
        return { prop: this.sortProp, order: this.sortOrder };
      }
      return {};
    },

    tableSortKey() {
      // Key changes when sort changes, forcing table to re-render with new default-sort
      return `${this.sortProp || 'none'}-${this.sortOrder || 'none'}`;
    },
  },

  props: {
    componentsMap: {},
  },

  watch: {
    globalCampaign(newVal) {
      if (!newVal || !newVal.id) {
        return;
      }

      if (!this.hasBootstrappedInitialSearch) {
        const runInitialLoad = () => {
          if (this.hasBootstrappedInitialSearch) {
            return;
          }
          this.hasBootstrappedInitialSearch = true;
          this.runInitialSearch({ preservePage: true });
          this.retrieveProductCount();
        };

        const waitForEvents =
          this.eventsPromise && typeof this.eventsPromise.then === "function"
            ? this.eventsPromise
            : this.retrieveEvents();

        this.eventsPromise = waitForEvents;
        waitForEvents.then(runInitialLoad).catch(runInitialLoad);
        return;
      }

      this.ProductList = [];
      this.ProductSubList = [];
      const q = this.$route.query || {};
      const hasFilters = !!(
        (this.filter &&
          (this.filter.experimentalCode ||
            this.filter.name ||
            this.filter.brand ||
            this.filter.event)) ||
        q.experimentalCode ||
        q.name ||
        q.brand ||
        q.event
      );

      if (hasFilters) {
        const ensureEvents =
          this.EventsList && this.EventsList.length
            ? Promise.resolve()
            : this.retrieveEvents();
        ensureEvents
          .then(() => {
            this.runInitialSearch({ preservePage: true });
          })
          .catch(() => {
            this.runInitialSearch({ preservePage: true });
          });
      } else {
        this.retrieveProducts({
          preservePage: true,
          targetPage: this.initialPage || 1,
        });
      }
      this.retrieveProductCount();
    },
    $route() {
      // Keep UI in sync with URL when navigating back/forward (like ProductionAdmin)
      this.restoreFromQuery();
      // Use $nextTick to ensure filter restoration completes before running search
      this.$nextTick(() => {
        // Check both component state and query params to determine if filters exist
        // This ensures filters are detected even if component data hasn't updated yet
        const q = this.$route.query || {};
        const hasFilters = !!(
          (this.filter && (this.filter.experimentalCode || this.filter.name || this.filter.brand || this.filter.event)) ||
          q.experimentalCode || q.name || q.brand || q.event
        );
        
        if (this.globalCampaign && this.globalCampaign.id) {
          if (hasFilters) {
            // Ensure events are loaded before running search (needed for event filter)
            if (this.EventsList.length === 0 && q.event) {
              this.retrieveEvents().then(() => {
                // Route is source of truth, preserve page from URL
                this.runInitialSearch({ preservePage: true });
              });
            } else {
              // Route is source of truth, preserve page from URL
              this.runInitialSearch({ preservePage: true });
            }
          } else {
            // Even without filters, reload products to preserve page/sort from URL
            this.retrieveProducts({ 
              preservePage: true, 
              targetPage: this.initialPage || 1 
            });
          }
        }
        // Sync pagination after route change
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
            this.$refs.pagination.currentChange(this.initialPage || 1);
          }
        });
      });
    },
  },

  data() {
    return {
      selectedProduct: null,
      selectedBrand: null,
      selectedEvent: null,

      product: {
        event: {},
      },

      ProductList: [],
      ProductSubList: [],
      cantidad: 100,

      EventsList: [],
      eventsPromise: null,
      hasBootstrappedInitialSearch: false,

      filter: {
        experimentalCode: null,
        name: null,
        brand: null,
        event: null,
      },
      initialPage: 1,
      sortProp: null,
      sortOrder: null,
      isUpdatingRoute: false,
    };
  },

  methods: {
    retrieveProducts({ preservePage = false, targetPage = null } = {}) {
      // Only clear filter if not preserving page (i.e., not loading from URL)
      // When loading from URL, we want to keep the filters that were restored from query
      if (!preservePage) {
        this.filter = {};
        this.filter.campaignId = this.globalCampaign
          ? this.globalCampaign.id
          : null;
      } else {
        // When preserving page, only ensure campaignId is set without clearing other filters
        if (!this.filter) {
          this.filter = {};
        }
        this.filter.campaignId = this.globalCampaign
          ? this.globalCampaign.id
          : null;
      }
      this.$store
        .dispatch("product/retrieveProducts", this.filter)
        .then((res) => {
          let processedList = res;
          console.log(processedList); //eslint-disable-line
          // Translate items
          for (var i = 0; i < processedList.length; i++) {
            this.translate(processedList[i]);
          }
          // Apply sorting if sort parameters are present (before setting ProductList)
          if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
            const sorted = this.$refs.pagination.handleSortChangePagination({
              prop: this.sortProp,
              order: this.sortOrder
            }, processedList);
            if (Array.isArray(sorted)) {
              processedList = sorted;
            }
          }
          // Set the processed list
          this.ProductList = processedList;
          
          // Sync pagination after loading - use double nextTick to ensure pagination component has processed the list
          const resolvedTarget = typeof targetPage === "number" && targetPage > 0
            ? targetPage
            : this.initialPage || 1;
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                this.$refs.pagination.currentChange(resolvedTarget);
              }
            });
          });
          // Only update route query if not preserving page (to avoid overwriting URL params during initial load)
          if (!preservePage) {
            this.updateRouteQuery();
          }
          // When preservePage is true, the URL already has the correct state, so we don't update it
        });
    },

    retrieveProductsBySearch({ preservePage = false } = {}) {
      // Always use component filter values directly (like ProductionAdmin)
      // The query is only used in restoreFromQuery() to set component values initially
      // After that, we always respect component state, even if it's null
      // This ensures filters restored from URL are properly used
      
      // Normalize empty strings to null (user cleared a filter)
      if (this.filter.experimentalCode == "") {
        this.filter.experimentalCode = null;
      }
      if (this.filter.name == "") {
        this.filter.name = null;
      }
      if (this.filter.brand == "") {
        this.filter.brand = null;
      }
      if (this.filter.event == "") {
        this.filter.event = null;
      }

      // Check if any filters are set (use component state directly)
      const hasFilters = !!(
        this.filter.experimentalCode ||
        this.filter.name ||
        this.filter.brand ||
        this.filter.event
      );

      if (!hasFilters) {
        // No filters, use regular retrieve
        this.retrieveProducts({ preservePage });
      } else {
        // Has filters, use search API
        // Ensure campaignId is set
        this.filter.campaignId = this.globalCampaign
          ? this.globalCampaign.id
          : null;
        this.$store
          .dispatch("product/retrieveProductsBySearch", this.filter)
          .then((res) => {
            this.ProductList = res;
            for (var i = 0; i < this.ProductList.length; i++) {
              this.translate(this.ProductList[i]);
            }
            
            // Apply sorting if sort parameters are present
            if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
              this.ProductList = this.$refs.pagination.handleSortChangePagination({
                prop: this.sortProp,
                order: this.sortOrder
              }, this.ProductList);
            }
            
            const targetPage = preservePage ? this.initialPage || 1 : 1;
            if (!preservePage) {
              this.initialPage = 1;
            }
            
            // Sync pagination after loading
            this.$nextTick(() => {
              if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                this.$refs.pagination.currentChange(targetPage);
              }
            });
            
            // Update URL after search
            if (preservePage) {
              this.updateRouteQuery();
            } else {
              this.updateRouteQuery({ page: 1 });
            }
          });
      }
    },

    add() {
      this.$router.push({
        name: `ProductEdition`,
        params: { id: "0" },
        query: this.$route.query,
      });
    },

    edit(id) {
      this.$router.push({
        name: `ProductEdition`,
        params: { id: id },
        query: this.$route.query,
      });
      //console.log(this.id);//eslint-disable-line
    },

    deleteProduct(id) {
      this.$confirm(
        "Está seguro que quiere eliminar el producto?",
        "Eliminar Producto",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.$store.dispatch("product/deleteProduct", id).then((res) => {
          if (res.status == "OK") {
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["productDeleted"],
              position: "bottom-right",
            });
            this.runInitialSearch({ preservePage: true });
            this.retrieveProductCount();
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["cantDeleteProduct"],
              position: "bottom-right",
            });
          }
        });
      });
    },

    retrieveEvents() {
      return this.$store.dispatch("event/retrieveEvents").then((res) => {
        this.EventsList = res;
        return res;
      });
    },

    translate(item) {
      if (item.cropType == "soy") {
        item.cropType = this.i18nValues["soy"];
      }
      if (item.cropType == "soyRD") {
        item.cropType = this.i18nValues["soyRD"];
      }
      if (item.cropType == "corn") {
        item.cropType = this.i18nValues["corn"];
      }
    },

    retrieveProductCount() {
      const filter = {
        campaignId: this.globalCampaign ? this.globalCampaign.id : null
      };
      this.$store
        .dispatch("product/countProducts", filter)
        .then((res) => {
          this.cantidad = res;
        });
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      const sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (!sortChanged) {
        return;
      }
      
      // OLD BEHAVIOR: Reset to page 1 when sorting (commented out for testing)
      // this.ProductList = this.$refs.pagination.handleSortChangePagination(event);
      // this.initialPage = 1;
      // this.updateRouteQuery({
      //   sortProp: this.sortProp || undefined,
      //   sortOrder: this.sortOrder || undefined,
      //   page: 1,
      // });
      // this.$nextTick(() => {
      //   if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
      //     this.$refs.pagination.currentChange(1);
      //   }
      // });
      
      // NEW BEHAVIOR: Preserve current page when sorting (for testing)
      const currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex 
        ? this.$refs.pagination.tableIndex 
        : this.initialPage || 1;
      this.initialPage = currentPage;
      
      // Try pagination component sorting first
      let sorted = null;
      if (this.$refs.pagination && typeof this.$refs.pagination.handleSortChangePagination === "function") {
        sorted = this.$refs.pagination.handleSortChangePagination(event);
      }
      
      // Fallback to local sorting if pagination component sorting fails or returns non-array
      if (!Array.isArray(sorted)) {
        sorted = this.sortProductsLocally(
          this.ProductList,
          this.sortProp,
          this.sortOrder
        );
      }
      
      if (Array.isArray(sorted)) {
        this.ProductList = sorted;
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
            this.$refs.pagination.currentChange(currentPage);
          } else if (Array.isArray(this.ProductList)) {
            const start = (currentPage - 1) * this.pageSize;
            this.ProductSubList = this.ProductList.slice(start, start + this.pageSize);
          }
        });
      }
      this.updateRouteQuery({
        sortProp: this.sortProp || undefined,
        sortOrder: this.sortOrder || undefined,
        page: currentPage,
      });
    },

    sortProductsLocally(list, prop, order) {
      if (!Array.isArray(list) || !prop || !order) {
        return list;
      }
      const direction = order === "descending" ? -1 : 1;
      
      // Force string sorting for brand column to ensure proper alphabetical sorting
      const forceStringProps = ["brand"];
      const treatAsString = forceStringProps.includes(prop);
      
      return [...list].sort((a, b) => {
        const aVal = this.getValueByPath(a, prop);
        const bVal = this.getValueByPath(b, prop);
        
        if (this.isEmptyValue(aVal) && this.isEmptyValue(bVal)) {
          return 0;
        }
        if (this.isEmptyValue(aVal)) {
          return 1;
        }
        if (this.isEmptyValue(bVal)) {
          return -1;
        }
        
        // For brand and other string columns, always sort as strings
        // For other columns, use numeric sorting if both values are numeric
        if (!treatAsString && this.isNumericValue(aVal) && this.isNumericValue(bVal)) {
          return (Number(aVal) - Number(bVal)) * direction;
        }
        
        // Use localeCompare for proper string sorting
        const comparison = String(aVal).localeCompare(String(bVal), undefined, {
          sensitivity: "base",
        });
        return comparison * direction;
      });
    },

    getValueByPath(item, path) {
      if (!item || !path) {
        return null;
      }
      return path.split(".").reduce((acc, segment) => {
        if (acc === null || acc === undefined) {
          return null;
        }
        return acc[segment];
      }, item);
    },

    isEmptyValue(value) {
      return value === null || value === undefined || value === "";
    },

    isNumericValue(value) {
      if (typeof value === "number") {
        return !isNaN(value);
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      return !isNaN(Number(value));
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.ProductSubList = evt.list;
      }
      const currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex ? this.$refs.pagination.tableIndex : this.initialPage;
      this.updateRouteQuery({ page: currentIdx });
    },

    setCurrentPage(idx) {
      if (typeof idx === 'number') {
        this.updateRouteQuery({ page: idx });
      }
    },

    hasFiltersInQuery() {
      const q = this.$route.query || {};
      return !!(
        q.experimentalCode ||
        q.name ||
        q.brand ||
        q.event ||
        // Also check component state in case query hasn't updated yet
        (this.filter && this.filter.experimentalCode) ||
        (this.filter && this.filter.name) ||
        (this.filter && this.filter.brand) ||
        (this.filter && this.filter.event)
      );
    },

    runInitialSearch({ preservePage = false } = {}) {
      // Use filtered search (like OrdersAdmin) - it will automatically use filters if present
      // The search method checks filters and calls the appropriate API
      this.retrieveProductsBySearch({ preservePage });
    },

    runInitialSearchIfFiltersPresent() {
      // Legacy method - kept for compatibility but should use runInitialSearch instead
      this.runInitialSearch({ preservePage: true });
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      this.filter = this.filter || {};
      // Restore or clear each filter based on query presence
      this.filter.experimentalCode = q.experimentalCode || null;
      this.filter.name = q.name || null;
      this.filter.brand = q.brand || null;
      // Event from URL is a string, convert to number if it's a valid number
      // The select uses item.id (number) as the value, so we need to convert the string to number
      if (q.event) {
        const eventNum = Number(q.event);
        this.filter.event = !isNaN(eventNum) ? eventNum : null;
      } else {
        this.filter.event = null;
      }
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    updateRouteQuery(partial) {
      const base = this.buildQueryFromState();
      const next = Object.assign({}, base, partial || {});
      const cleaned = {};
      Object.keys(next).forEach(k => {
        const v = next[k];
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      this.isUpdatingRoute = true;
      const done = () => { this.$nextTick(() => { this.isUpdatingRoute = false; }); };
      this.$router.replace({ query: cleaned }).then(done).catch(done);
    },

    buildQueryFromState() {
      const q = {};
      if (this.filter) {
        if (this.filter.experimentalCode) q.experimentalCode = this.filter.experimentalCode;
        if (this.filter.name) q.name = this.filter.name;
        if (this.filter.brand) q.brand = this.filter.brand;
        if (this.filter.event) q.event = this.filter.event;
      }
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) q.page = this.$refs.pagination.tableIndex;
      else if (this.initialPage) q.page = this.initialPage;
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = this.globalCampaign.id;
      return q;
    },
  },
};
</script>

<style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
}


/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>
